import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "@/lib/utils";

/**
 * Reklaim deltas vs the v4 shadcn registry (preserved on REK-1563 Stack 2 refresh):
 * - `h-4` (16px) instead of v4's `h-2` (8px) -- meatier bar for the dashboard's
 *   prominent jackpot / pool / earnings progress indicators where the bar IS
 *   the visual hierarchy element, not a thin secondary cue.
 * - `bg-secondary` (neutral gray) instead of v4's `bg-primary/20` (faded yellow) --
 *   we don't pre-tint the unfilled track with the brand color; the FILL is
 *   primary-yellow and the contrast against gray is intentional.
 *
 * Do NOT replace this file with `npx shadcn add progress --overwrite` -- it would
 * shrink and yellow-tint every progress bar (pool countdown, jackpot tracker,
 * onboarding wizard, password strength). See PoolCountdown.tsx + WalletDisplay.tsx
 * for the load-bearing consumers.
 */
const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn("relative h-4 w-full overflow-hidden rounded-full bg-secondary", className)}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className="h-full w-full flex-1 bg-primary transition-all"
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
